import { Box } from "@mui/material";

export default function CustomBox(props) {
  const { lh, mw, fw, fs, children, style, ...rest } = props;

  return (
    <Box
      style={{
        fontWeight: fw,
        fontSize: fs,
        maxWidth: mw,
        lineHeight: lh,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
